import config from "utils/config";
import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
  ApolloLink,
} from "@apollo/client";
import enhancedAuthLink from "../apollo/authLink";
import enhancedErrorLink from "../apollo/errorLink";

const AUTH_TOKEN_KEY = "@lookme::authToken";

const httpLink = createHttpLink({
  uri: config.get("GRAPHQL_URL"),
  fetch: (uri, options) => {
    // Add timeout to fetch requests (30 seconds)
    const controller = new AbortController();
    const timeout = setTimeout(() => {
      controller.abort(new Error('Request timeout - Yêu cầu quá thời gian chờ'));
    }, 30000); // 30 second timeout

    return fetch(uri, {
      ...options,
      signal: controller.signal,
    }).finally(() => {
      clearTimeout(timeout);
    });
  },
});

const cache = new InMemoryCache({
  typePolicies: {
    Booking: {
      fields: {
        user: {
          read(existing) {
            // Handle null user field gracefully
            return existing || null;
          },
        },
      },
    },
    Query: {
      fields: {
        CampaignPackages: {
          keyArgs: ["where", "orderBy"],
          merge(existing, incoming, { args }) {
            // If it's the first page or we're reloading, replace entirely
            if (!args?.page || args.page === 1 || !existing) {
              return incoming;
            }
            // Otherwise merge for pagination
            return {
              ...incoming,
              docs: [...(existing?.docs || []), ...(incoming?.docs || [])],
            };
          },
        },
      },
    },
    CampaignPackage: {
      keyFields: ["id"],
    },
  },
});

export const createApolloClient = () => {
  try {
    return new ApolloClient({
      link: ApolloLink.from([enhancedErrorLink, enhancedAuthLink, httpLink]),
      cache,
      defaultOptions: {
        watchQuery: {
          errorPolicy: 'none', // Throw errors so errorLink can handle them
          fetchPolicy: 'cache-first',
        },
        query: {
          errorPolicy: 'none', // Throw errors so errorLink can handle them
          fetchPolicy: 'cache-first',
        },
        mutate: {
          errorPolicy: 'none', // Throw errors so errorLink can handle them
          fetchPolicy: 'network-only', // Mutations always go to network
          awaitRefetchQueries: true, // Wait for refetch queries to complete
        },
      },
    });
  } catch (error) {
    console.error("Error creating Apollo client:", error);
    throw error;
  }
};

const client = createApolloClient();

export { default as builder } from "./builder";
export default client;